import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

const apiUrl = `${process.env.REACT_APP_URL}`;
const bearerToken = localStorage.getItem("token_bizops");

async function makeHttpRequest(url, method, headers, body = null, token = null) {
  try {
    const response = await fetch(apiUrl + url, {
      method: method,
      headers: {
        ...headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${token ? token : bearerToken}`,
      },
      body: body ? JSON.stringify(body) : null,
      redirect: "follow",
    });

    if (response.status === 401) {
      logout();
    }
    if (!response.ok) {
      const error = await response.json();
      if (!error.status) {
        return error;
      } else {
        throw new Error(`Something went wrong: ${response.statusText}`);
      }
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const data = await response.json();
      return data;
    } else {
      return response;
    }
  } catch (error) {
    throw error;
  }
}

async function makeHttpRequestFormData(url, method, headers, data) {
  try {
    const response = await fetch(apiUrl + url, {
      method,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
      body: data,
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
  }
}

async function makeHttpRequestBlob(url, method, headers, body = null, token = null) {
  try {
    const headers = {
      Authorization: `Bearer ${token ? token : bearerToken}`,
    };

    // hanya tambahkan Content-Type kalau ada body
    if (body) {
      headers["Content-Type"] = "application/json";
    }

    const response = await fetch(apiUrl + url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (response.status === 401) {
      // di sini bisa redirect ke login / logout
      throw new Error("Unauthorized (401) – Token mungkin expired atau salah");
    }

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Download failed: ${errorText}`);
    }

    return await response.blob();
  } catch (error) {
    console.error("makeHttpRequestBlob error:", error);
    throw error;
  }
}

async function makeHttpRequestBlobParams(url, method, headers = {}, params = {}, token = null) {
  try {
    const headers = {
      Authorization: `Bearer ${token ? token : bearerToken}`,
    };

    const queryString = new URLSearchParams(params).toString();
    const fullUrl = `${apiUrl}${url}${queryString ? `?${queryString}` : ""}`;

    const response = await fetch(fullUrl, {
      method,
      headers,
    });

    if (response.status === 401) {
      throw new Error("Unauthorized (401) – Token mungkin expired atau salah");
    }

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Download failed: ${errorText}`);
    }

    return await response.blob();
  } catch (error) {
    console.error("makeHttpRequestBlobParams error:", error);
    throw error;
  }
}

const decodeBearerToken = () => {
  try {
    const token = localStorage.getItem("token_bizops");
    if (token) {
      const decodedToken = jwt_decode(token);
      return decodedToken;
    }
    return null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

const logout = () => {
  localStorage.removeItem("token_bizops");
  localStorage.removeItem("menuNames");
  localStorage.removeItem("positionNames");
  localStorage.removeItem("supplierNames");
  localStorage.clear();
  window.location.href = "/authentication/sign-in";
};

const calculateOutStanding = (items) => {
  return items.reduce((accumulator, item) => {
    const subtotal = item.qty_process * item.hna;
    return accumulator + subtotal;
  }, 0);
};

const validateDataQtyPlog = (data) => {
  const validationFailures = [];
  data.forEach((item) => {
    if (item.qty_outstanding < item.qty_process) {
      validationFailures.push(`Qty Process more than jumlah for item with id ${item.id}`);
    }
  });

  return validationFailures;
};

const mergePosition = (data) => {
  return data.reduce((acc, obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === 1) {
        acc[key] = obj[key];
      }
    });
    return acc;
  }, {});
};

function loadAndParseLocalStorage(key) {
  const storedLocalStorage = localStorage.getItem(key);
  if (storedLocalStorage) {
    try {
      const convert = JSON.parse(storedLocalStorage);
      if (key == "positionNames") {
        let result = mergePosition(convert);
        return result;
      }
      return convert;
    } catch (error) {
      console.error("Error parsing stored position names:", error);
    }
  }
}
const removeDuplicatesWithHighestPoint = (array) => {
  const map = new Map();

  array.forEach((item) => {
    const existingItem = map.get(item.item_code);
    if (!existingItem || item.point > existingItem.point) {
      map.set(item.item_code, item);
    }
  });

  return Array.from(map.values());
};

const formatRupiah = (value) => {
  if (!value) return "";

  const numberString = value.replace(/[^,\d]/g, "");
  const split = numberString.split(",");
  const sisa = split[0].length % 3;
  let rupiah = split[0].substr(0, sisa);
  const ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  if (ribuan) {
    const separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  return split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
};

export {
  makeHttpRequest,
  calculateOutStanding,
  decodeBearerToken,
  validateDataQtyPlog,
  logout,
  loadAndParseLocalStorage,
  makeHttpRequestFormData,
  removeDuplicatesWithHighestPoint,
  makeHttpRequestBlob,
  makeHttpRequestBlobParams,
  formatRupiah,
};
